<div class="home container" *ngIf="isAuthenticated()">
    <h1>{{ 'home.greeting' | translate:{ username: account.firstName } }}</h1>
    <p>{{ 'home.intro' | translate }}</p>
    <markdown [src]="'home.changelog-file' | translate"></markdown>
</div>
<div class="home login" *ngIf="!isAuthenticated()">
    <div id="login-container-fr" *ngIf="currentLang == 'fr'"></div>
    <div id="login-container-en" *ngIf="currentLang == 'en'"></div>
</div>



// WEBPACK FOOTER //
// ./src/app/home/home.component.html